import modularLoad from './modularload';
import { APP_NAME, $document, $html } from '../utils/environment';
import AbstractModule from './AbstractModule';
import { EVENT as NEWS_EVENTS } from './News';
import {Event as CalendarEvent} from './Calendar';

const MODULE_NAME = 'Load';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

export const EVENT = {
    INIT_MODULES: `initModules.${EVENT_NAMESPACE}`,
    INIT_SCOPED_MODULES: `initScopedModules.${EVENT_NAMESPACE}`,
    DELETE_SCOPED_MODULES: `deleteScopedModules.${EVENT_NAMESPACE}`,
    GOTO: `goTo.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);
    }

    init() {
        const load = new modularLoad({
            enterDelay: 600,
            loadingClass: 'has-dom-loading',
            loadedClass: 'has-dom-loaded',
            readyClass: 'has-dom-animated',
            transitionsPrefix: 'is-transition-',
            transitions: {
                map: {
                    enterDelay: 0
                },
                filter: {
                    enterDelay: 600
                },
                news: {
                    enterDelay: 300,
                    loadingClass: 'is-loading',
                    loadedClass: 'is-loaded',
                    readyClass: 'is-animated'
                }
            }
        });

        load.on('loading', (transition) => {

            $html.removeClass('has-nav-open has-breadcrumb-open has-search-open has-aside-select-open');
            $('.js-nav-main-section.is-open').removeClass('is-open');
            $('.js-header-bg.is-open').removeClass('is-open');
        });

        load.on('loaded', (transition, oldContainer, newContainer) => {
            $document.triggerHandler({
                type: EVENT.DELETE_SCOPED_MODULES,
                $scope: $(oldContainer)
            });

            $document.triggerHandler({
                type: EVENT.INIT_SCOPED_MODULES,
                $scope: $(newContainer)
            });

            if(transition === 'news') {
                $document.triggerHandler({
                    type: NEWS_EVENTS.SET_ACTIVE,
                    id: newContainer.getAttribute('data-current')
                });

                $document.triggerHandler({
                    type: 'scrollTo.LocomotiveScroll',
                    options: {
                        speed: 300,
                        toTop: true
                    }
                })

                $document.triggerHandler({
                    type: 'rebuild.LocomotiveScroll'
                })

                if($(newContainer).attr('data-category') !== undefined) {
                    $('.js-breadcrumb').attr('data-id',$(newContainer).attr('data-category'))
                }
            }

        });

        $document.on(EVENT.GOTO, (e) => {
            load.goTo(e.href, e.transition, e.isUrl);
        })
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
